import React from 'react';

const RemoteAudioButton = ({ onClick, isMuted }) => {
  return (
    <div className="relative group">
      <button
        onClick={onClick}
        className="relative p-3 hover:scale-110 active:scale-95 transition-all duration-300"
        title={isMuted ? 'Unmute Their Audio' : 'Mute Their Audio'}
      >
        {/* Glass effect background */}
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-white/10 to-transparent backdrop-blur-sm border border-white/20"></div>

        {/* Animated glow ring */}
        <div className={`
          absolute inset-0 rounded-2xl border-2 opacity-30 transition-all duration-500
          ${isMuted ? 'border-red-400/50 animate-pulse' : 'border-blue-400/50'}
        `}></div>

        {/* Emoji with floating animation */}
        <div className="relative z-10">
          <span className={`
            text-4xl block transition-all duration-500
            ${isMuted ? 'opacity-60' : 'animate-float'}
          `}>
            {isMuted ? '🔇' : '🔊'}
          </span>
        </div>

        {/* Status indicator dot */}
        <div className={`
          absolute -top-1 -right-1 w-3 h-3 rounded-full border-2 border-gray-900 transition-all duration-300
          ${isMuted ? 'bg-red-500' : 'bg-green-500 animate-pulse'}
        `}></div>
      </button>

      {/* Premium Tooltip */}
      <div className="absolute -top-16 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none">
        <div className="relative">
          <div className="bg-gray-900/95 backdrop-blur-md text-white text-sm px-4 py-3 rounded-xl shadow-2xl border border-white/10 whitespace-nowrap">
            <div className="flex items-center gap-2">
              <span className="text-lg">{isMuted ? '🔇' : '🔊'}</span>
              <span>{isMuted ? 'Their audio muted' : 'Their audio active'}</span>
            </div>
          </div>
          {/* Tooltip arrow */}
          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 rotate-45 w-3 h-3 bg-gray-900/95 border-r border-b border-white/10"></div>
        </div>
      </div>
    </div>
  );
};

export default RemoteAudioButton;
